import { render, staticRenderFns } from "./TextStyleDefinition.vue?vue&type=template&id=1dcadbd8&scoped=true"
import script from "./TextStyleDefinition.vue?vue&type=script&lang=ts"
export * from "./TextStyleDefinition.vue?vue&type=script&lang=ts"
import style0 from "./TextStyleDefinition.vue?vue&type=style&index=0&id=1dcadbd8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcadbd8",
  null
  
)

export default component.exports